// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceAndActionsStyle } from "@conklin/App/Components/Product/ProductPriceAndActions";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            padding: 0;
        `,
    },
};

productPriceAndActionsStyle.priceAndQtyContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 8px;

        &:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.productFields = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: end;
        &:empty,
        & > div:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.addToCartActions = {
    css: css`
        display: flex;
        flex: 1;
        gap: 8px;
    `,
};

productPriceAndActionsStyle.addToCartButton = {
    sizeVariant: "small",
    css: css`
        width: 100%;
        flex: 1;
    `,
};

productPriceAndActionsStyle.productImageStyles = {
    wrapper: {
        css: css`
            margin-right: auto;
            margin-left: 0px;
        `,
    },
};

productPriceAndActionsStyle.productAvailableStyles = {
    messageGridItem: {
        width: 6,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 6,
    },
};

productPriceAndActionsStyle.productUnitOfMeasureSelectStyles = {
    cssOverrides: {
        formField: css`
            max-width: 91px;
        `,
    },
};
